export enum SubFlow {
  TemplateSubflowKey = 'template_subflow_key',
  Bike = 'bike',
  Common = 'common',
  Contents = 'contents',
  ContentsComfort = 'contents-comfort',
  DogLiabilityDe = 'dog-liability-de',
  Drone = 'drone',
  LegalBasis = 'legal-basis',
  LegalBasis3 = 'legal-basis-3',
  LegalComfort3 = 'legal-comfort-3',
  LegalComfortBasic = 'legal-comfort-basic',
  LegalStandard = 'legal-standard',
  LegalPremium = 'legal-premium',
  LegalNeo = 'legal-neo',
  Legal = 'legal',
  LiabilityPremium = 'liability-premium',
  Liability = 'liability',
  PaymentAndConfirmation = 'paymentAndConfirmation',
  TestFlow = 'test-flow',
  CoverageExtension = 'coverageExtension',
  UnderwritingValidation = 'underwritingValidation',
  DentalOttonova75 = 'dental-ottonova-75',
  DentalOttonova90 = 'dental-ottonova-90',
  DentalOttonova100 = 'dental-ottonova-100',
  LiabilityNxt = 'liability-nxt',
  DogLiability = 'dog-liability',
  ContentsNxt = 'contents-nxt',
  UnifiedLegalComfort3 = 'unified-legal-comfort-3',
  BundleSummary = 'bundle_summary',
  HouseholdAt = 'household-at',
  PetHealth = 'pet-health',
  HomeFr = 'home-fr',
  IncomeProtection = 'income-protection',
  PrivatePension = 'private-pension',
  PrivateHealth = 'private-health',
  ChildSaving = 'child-saving',
  TermLife = 'term-life',
  TransferFlowOptOut = 'transfer-flow-opt-out',
  TransferFlowOptIn = 'transfer-flow-opt-in',
  TravelHealth = 'travel-health',
  LegalRoland = 'legal-roland',
  PublicHealth = 'public-health',
  Dental = 'dental',
  PublicHealthSwitchCalculator = 'public-health-switch-calculator',
  PublicHealthSwitchApplication = 'public-health-switch-application',
}

// [hygen-marker] subflow type
